import { render, staticRenderFns } from "./myCourseList.vue?vue&type=template&id=70de5922&scoped=true&"
import script from "./myCourseList.vue?vue&type=script&lang=js&"
export * from "./myCourseList.vue?vue&type=script&lang=js&"
import style0 from "./myCourseList.vue?vue&type=style&index=0&id=70de5922&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de5922",
  null
  
)

export default component.exports